import login from "Language/login";
import footer from "Language/footer";

const resources = {
  lng: "it",
  resources: {
    en: {
      translation: {
        login: login.en.translation,
        footer: footer.en.translation,
        ciao: "hello",
        yes: "Yes",
        no: "No",
        of: "Of",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        menu: "Menu",
        location: "Location",
        service: "Service",
        price: "Price",
        not_reviewed: "Not reviewed",
        level_poor: "Very Poor",
        level_low: "Low",
        level_plenty: "Average",
        level_good: "Good",
        level_excellent: "Superb",
        level_outstanding: "Outstanding",
        save_success_title: "Good job!",
        show_more: "Show more",
        save_success_text: "Your changes have been saved successfully",
        save_error_title: "Oops, something went wrong!",
        save_error_text:
          "An error occurred, please wait a few moments and try again. If the problem persists, contact us at support@foodiestrip.com",
        popup_not_authorized_title: "Oops, something went wrong!",
        popup_not_authorized_text:
          "It looks like you don't have permission to manage to this page, please contact us at support@foodiestrip.com",
        editing_other_section_title: "Oops!",
        editing_other_section_text:
          "You are editing another section. Make sure you have finished before moving on to the next one.",
        view_plans: "View plans",
        service_not_paid_stats:
          "Analyze your target through our advanced statistics! Discover the Essential, Essential plus and Premium plans in the dedicated section.",
        or: "or"
      }
    },
    it: {
      translation: {
        login: login.it.translation,
        footer: footer.it.translation,
        ciao: "ciao",
        yes: "Si",
        no: "No",
        of: "di",
        save: "Salva",
        cancel: "Annulla",
        edit: "Modifica",
        delete: "Cancella",
        menu: "Menu",
        location: "Location",
        service: "Servizio",
        price: "Prezzo",
        not_reviewed: "Non recensito",
        level_poor: "Molto Scarso",
        level_low: "Mediocre",
        level_plenty: "Sufficiente",
        level_good: "Buono",
        level_excellent: "Ottimo",
        level_outstanding: "Eccellente",
        save_success_title: "Ottimo lavoro!",
        show_more: "Mostra altro",
        save_success_text: "Le tue modifiche sono state salvate con successo",
        save_error_title: "Ops, qualcosa è andato storto!",
        save_error_text:
          "Si è verificato un problema, riprova tra poco. Se il problema persiste scrivici a support@foodiestrip.com",
        popup_not_authorized_title: "Ops, qualcosa è andato storto!",
        popup_not_authorized_text:
          "Sembra che tu non abbia i permessi per gestire questa attività, per favore contattaci a support@foodiestrip.com",
        editing_other_section_title: "Attenzione!",
        editing_other_section_text:
          "Stai già modificando un'altra sezione. Assicurati di aver terminato prima di passare alla prossima.",
        view_plans: "Vai ai piani",
        service_not_paid_stats:
          "Analizza il tuo target attraverso le statistiche avanzate di foodiestrip! Scopri i piani Essential, Essential plus e Premium nella sezione dedicata.",
        or: "o"
      }
    }
  }
};

export default resources;



// WEBPACK FOOTER //
// ./src/Language/resources.js